export default {"src":"/stays/_next/static/media/security.2b23af80.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};